import i18n from "@/config/i18n";

type CmsTranslations = Record<string, Record<string, string>>;

// At init time the SPA merges CMS fragments into the `translation` namespace
// under the `cmsTranslations` key (see packs/config/i18n.ts). When the user
// crosses to a different distribution slug via SPA navigation we need to swap
// that slice in-place so subsequent `t("cmsTranslations.*")` lookups resolve
// against the new distribution's copy.
export const updateCmsTranslations = (cmsTranslations: CmsTranslations) => {
  for (const [lang, resources] of Object.entries(cmsTranslations)) {
    i18n.addResourceBundle(lang, "translation", { cmsTranslations: resources }, true, true);
  }
};
